import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import API from '../../utils/api';
import CategoryPage from './CategoryPage';
import SubcategoryPage from './SubcategoryPage';
import ProductDetailPage from '../ProductDetailPage';

export default function SlugResolver() {
  const { categorySlug, seg1, seg2 } = useParams();

  // ── /category/:seg1/:seg2  — seg1=category, seg2=subcategory or product
  if (seg1 && seg2) {
    return <TwoSegmentResolver seg1={seg1} seg2={seg2} />;
  }

  // ── /category/:seg1  — could be category (unlikely here since /:categorySlug handles root)
  if (seg1) {
    return <OneSegmentResolver slug={seg1} />;
  }

  // ── /:categorySlug  — root-level category slug
  if (categorySlug) {
    return <OneSegmentResolver slug={categorySlug} />;
  }

  return <div style={{ padding: '120px 0', textAlign: 'center' }}><h2>Page not found</h2></div>;
}

// Resolves a single slug: is it a category or a product?
function OneSegmentResolver({ slug }) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    API.get(`/catalog/public/categories/${slug}`)
      .then(() => setResult('category'))
      .catch(() => {
        API.get(`/catalog/public/products/${slug}`)
          .then(() => setResult('product'))
          .catch(() => setResult('notfound'));
      });
  }, [slug]);

  if (!result) return (
    <div style={{ padding: '120px 0', textAlign: 'center' }}>
      <div className="spinner" />
    </div>
  );

  if (result === 'category') return <CategoryPage />;
  if (result === 'product')  return <ProductDetailPage />;

  return (
    <div style={{ padding: '120px 0', textAlign: 'center' }}>
      <h2>Page not found</h2>
      <a href="/products" className="btn btn-primary" style={{ marginTop: 16 }}>
        Back to Products
      </a>
    </div>
  );
}

// Resolves /category/:seg1/:seg2 — seg2 could be subcategory or product
function TwoSegmentResolver({ seg1, seg2 }) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    // Check if seg2 is a product slug
    API.get(`/catalog/public/products/${seg2}`)
      .then(() => setResult('product'))
      .catch(() => setResult('subcategory'));
  }, [seg1, seg2]);

  if (!result) return (
    <div style={{ padding: '120px 0', textAlign: 'center' }}>
      <div className="spinner" />
    </div>
  );

  if (result === 'product')     return <ProductDetailPage />;
  if (result === 'subcategory') return <SubcategoryPage />;

  return (
    <div style={{ padding: '120px 0', textAlign: 'center' }}>
      <h2>Page not found</h2>
      <a href="/products" className="btn btn-primary" style={{ marginTop: 16 }}>
        Back to Products
      </a>
    </div>
  );
}